import React from 'react';
import { Result, Button } from 'antd';
import { withRouter, Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';


class Error404 extends React.Component {
    render() {
        const { t } = this.props;

        return (
            <Result
                status="404"
                title="404"
                subTitle={t('error404.sub_title', 'Sorry, the page you visited does not exist.')}
                extra={
                    <Link to='/login'>
                        <Button type="primary" target="" >{t('error404.back_home', 'Back Home')}</Button>
                    </Link>
                }
            />
        );
    }
}

export default withRouter(withTranslation()(Error404));


// WEBPACK FOOTER //
// ./src/containers/Layout/Error404.js